import * as yup from 'yup';
import { FORM_INPUT_ERROR_MSGS } from '../../../../constants/errors';

export const nameValidationSchema = yup.object().shape({
  name: yup.string().required(FORM_INPUT_ERROR_MSGS.REQUIRED('ussd report name'))
});
